import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const register_program_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/register_program`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'register_program_api');
  }
};

export const login_program_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/login_program`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'login_program_api');
  }
};

export const two_factor_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/two_factor`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'two_factor_api');
  }
};

export const code_check_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/code_check`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'code_check_api');
  }
};

export const after_successful_login_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/after_successful_login`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'after_successful_login_api');
  }
};

export const custfeature_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(`/api/custfeature`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'custfeature_api');
  }
};

export const user_session_data_access_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(
      `/api/user_session_data_access?userid=${data}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_access_api');
  }
};

export const topicprogram_api = async () => {
  try {
    const response = await axiosInstance.get(`/api/topicprogram`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'topicprogram_api');
  }
};

export const all_topic_grp_topic_api = async () => {
  try {
    const response = await axiosInstance.get(`/api/all_topic_data`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'all_topic_grp_topic_api');
  }
};

export const user_session_data_enroll_api = async ({ userid, selpymtid }) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_enroll?userid=${userid}&selpymtid=${selpymtid}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_enroll_api');
  }
};

export const user_session_data_configfree_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(
      `/api/user_session_data_configfree`,
      data
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_configfree_api');
  }
};

export const order_creation_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/order_creation`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'order_creation_api');
  }
};

export const create_checkout_session_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/create_checkout_session`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'create_checkout_session_api');
  }
};

export const confirm_checkout_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/confirm_checkout`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'confirm_checkout_api');
  }
};

export const free_14_days_trial_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/free_14_days_trial`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_14_days_trial_api');
  }
};

export const forgot_password_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/forgot_password`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'forgot_password_api');
  }
};

export const forgot_password_verify_api = async (data) => {
  try {
    const token = localStorage.getItem("F_Token");
    console.log(data);
    const response = await axiosInstance.post(`/api/forgot_password_verify`, data, {
      headers: { Authorization: "Bearer " + token },
    });
    console.log(response);
    return response;
  } catch (error) {
    throw handleApiError(error, 'forgot_password_verify_api');
  }
};

export const subscription_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/subscription`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'subscription_api');
  }
};
export const paypal_prorated_amount_api = async (data) => {
  try {
    console.log("paypal_prorated_amount_api data",data);
    const response = await axiosInstance.post(
      `/api/prorated-amount`,
      data
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, 'prorated-amount');
  }
};
// In your API service file (services/NewUI_API.js)
export const verify_paypal_payment_api = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/api/verify-paypal-payment`,
      data
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, 'verify-paypal-payment');
  }
};
export const cancel_subscription_api = async (data) => {
  try {
    const response = await axiosInstance.post(`/api/cancel_subscription`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'cancel_subscription_api');
  }
};

export const user_session_data_subpymt_api = async (data) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_subpymt?userid=${data}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_subpymt_api');
  }
};

export const user_session_data_subpymt_client_api = async (data) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_subpymt_client?userid=${data}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_subpymt_client_api');
  }
};

export const user_session_data_custsetup_sp_api = async ({
  sp_userid,
  ep_userid,
  speccode
}) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_custsetup?sp_userid=${sp_userid}&ep_userid=${ep_userid}&speccode=${encodeURIComponent(speccode)}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_custsetup_sp_api');
  }
};

export const user_session_data_custsetup_ep_api = async ({
  sp_userid,
  ep_userid,
}) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_session_data_custsetup?ep_userid=${ep_userid}&sp_userid=${sp_userid}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_session_data_custsetup_ep_api');
  }
};

export const dashboard_api = async () => {
  try {
    const response = await axiosInstance.get(`/api/dashboard`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'dashboard_api');
  }
};

export const dashboard_topicprogram_api = async () => {
  try {
    const response = await axiosInstance.get(`/api/dashboard_topicprogram`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'dashboard_topicprogram_api');
  }
};

export const dashboard_all_topic_grp_topic_api = async (topgrpcode) => {
  try {
    console.log(topgrpcode);
    const response = await axiosInstance.get(
      `/api/dashboard_all_topic_grp_topic?topgrpcode=[${topgrpcode}]`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'dashboard_all_topic_grp_topic_api');
  }
};

export const edit_program_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(`/api/edit_program`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'edit_program_api');
  }
};

export const getupdate_details_api = async ({userid}) => {
  try {
    const response = await axiosInstance.get(`/api/getupdate_details?userid=${userid}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'getupdate_details_api');
  }
};

export const reset_password_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/reset_password`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'reset_password_api');
  }
};

export const edit_suggestion_program_data_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(
      `/api/update_build_report_and_access_privilliges`,
      data
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'edit_suggestion_program_data_api');
  }
};

export const free_test_availability_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(
      `/api/free_test_availability?userid=${data.userid}&topiccodes=${data.topiccodes}`
    );
    console.log(response);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_test_availability_api');
  }
};

export const free_initialstep_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/free_initialstep`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_initialstep_api');
  }
};

export const free_responsequiz_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/free_responsequiz`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_responsequiz_api');
  }
};

export const free_revresponsequiz_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/free_revresponsequiz`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_revresponsequiz_api');
  }
};

export const free_sugg_build_report_and_access_privilliges_api = async (
  data
) => {
  try {
    console.log(data);
    const response = await axiosInstance.get(
      `/api/sugg_build_report_and_access_privilliges?topiccode=${data.topiccode}&userid=${data.userid}&guideselect=${data.guideselect}&useremail=${data.useremail}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_sugg_build_report_and_access_privilliges_api');
  }
};

export const free_sugg_update_build_report_and_access_privilliges_api = async (
  data
) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(
      `/api/sugg_update_build_report_and_access_privilliges`,
      data
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_sugg_update_build_report_and_access_privilliges_api');
  }
};

export const highlight_topicgrp_api = async (userid) => {
  try {
    console.log(userid);
    const response = await axiosInstance.get(
      `/api/highlight_topicgrp?userid=${userid}`
    );
    console.log(response);
    return response;
  } catch (error) {
    throw handleApiError(error, 'highlight_topicgrp_api');
  }
};

export const free_add_custadmin_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/free_add_custadmin`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'free_add_custadmin_api');
  }
};

export const selection_proceedchange_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.put(`/api/selection_proceedchange`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'selection_proceedchange_api');
  }
};

export const planendcheck_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/planendcheck`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'planendcheck_api');
  }
};

export const custplan_new_subscription_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/custplan_new_subscription`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'custplan_new_subscription_api');
  }
};

export const guvrixadmin_check_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/guvrixadmin_check`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'guvrixadmin_check_api');
  }
};

export const delete_paypal_subscription_api = async (data) => {
  try {
    console.log(data);
    const response = await axiosInstance.post(`/api/delete_paypal_subscription`, data);
    return response;
  } catch (error) {
    throw handleApiError(error, 'delete_paypal_subscription_api');
  }
};
export const get_paypal_subscription_api = async (data) => {
  try {
    console.log("API call data:", data);
    const subscriptionId = data.subscription_id || data;
    const response = await axiosInstance.get(`/api/get_paypal_subscription?subscription_id=${subscriptionId}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'get_paypal_subscription');
  }
};
export const checkSubscriptionStatus = async (data) => {
  try {
    console.log("API call data:", data);

    const response = await axiosInstance.get(`/api/check-subscription-status?user_id=${data}`);
    return response;
  } catch (error) {
    throw handleApiError(error, 'get_paypal_subscription');
  }
};
export const user_payment_details_api = async ({ userid}) => {
  try {
    const response = await axiosInstance.get(
      `/api/user_payment_details?userid=${userid}`
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'user_payment_details_api');
  }
};

export const validate_special_price_code_api = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/api/validate_special_price_code`,
      data
    );
    return response;
  } catch (error) {
    throw handleApiError(error, 'validate_special_price_code_api');
  }
};
